import { request } from '@umijs/max';

/** 分页获取目的地编码 GET /api/base/region */
export async function getRegionList(options?: { [key: string]: any }) {
  return request<API.ResponseBaseSchema<API.RegionResponseSchema[]>>('/api/base/region', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 分页获取会员或代理商等级 GET /api/base/level */
export async function getLevelList(
  params: API.LevelListParams,
  options?: { [key: string]: any },
) {
  return request<API.ResponseBaseSchema<API.ListResponseSchema<API.LevelResponseSchema>>>(
    '/api/base/level',
    {
      method: 'GET',
      params: {
        ...params,
      },
      ...(options || {}),
    },
  );
}

